<template>
  <v-row>
    <friend-list-compornent :is-login-user="isLoginUser" :key="componentKey" @rerender="rerender" />
  </v-row>
</template>

<script>
import FriendListCompornent from "../components/FriendList";

import { mapGetters } from 'vuex';

export default {
  components: { FriendListCompornent },

  computed: { ...mapGetters(["loginUserInfo"]) },

  created() {
    // userIdパラメータの有無でマイページか他ユーザーページか判定する.
    if (this.$route.params.user_id) this.isLoginUser = false
  },

  data: () => ({
    componentKey: 0,
    isLoginUser: true
  }),

  methods: {
    // 再レンダリングを行います.
    rerender() {
      this.componentKey++;
    },
  },

    watch: {
    // パラメータの変更を検知する
    $route(){
      // userIdパラメータの有無でマイページか他ユーザーページか判定する.
      if (this.$route.params.user_id) {
        this.isLoginUser = false
      } else {
        this.isLoginUser = true;
      }
    }
  },
};
</script>
